import { computed, type MaybeRefOrGetter, toValue } from 'vue';

import type { Chat, User } from '@/shared/api';

import { useUsersTypingStore } from './stores';

const useUserTyping = (
  userId: MaybeRefOrGetter<User['id']>,
  chatId: MaybeRefOrGetter<Chat['id']>,
) => {
  const typingStore = useUsersTypingStore();

  const isTyping = computed<boolean>(() =>
    typingStore.getUserTyping(toValue(userId), toValue(chatId)),
  );

  return { isTyping };
};

export { useUserTyping };
